/**
 * Code as it was written: a monospace block that keeps every space and line, wraps long lines (a minified JSON tool
 * input, a URL) instead of pushing the page sideways, and scrolls when it runs long. Mark highlights a search hit in
 * any text, code or prose. Proposed (coaching reading): the coaching reader's fenced code and tool entries.
 */
import type { ReactNode } from 'react'
import { cx } from '../cx'
import s from './CodeBlock.module.css'

export function CodeBlock({ label, tall, children }: { /** The language or what it is ("json", "Bash output"), above the block. */ label?: string | null; /** No height cap: the whole block shows. */ tall?: boolean; children: ReactNode }) {
  return (
    <figure className={s.box}>
      {label && <figcaption className={s.label}>{label}</figcaption>}
      <pre className={cx(s.code, tall && s.tall)} tabIndex={0}>
        <code>{children}</code>
      </pre>
    </figure>
  )
}

/** A search hit, marked in Dusk's soft wash (never Signal). */
export function Mark({ children }: { children: ReactNode }) {
  return <mark className={s.mark}>{children}</mark>
}
